import {BaseModel} from '../classes/base-model';
import {SelectionType} from './selection-type.enum';

export class ProductSelectionType extends BaseModel {
    ProductId: number;
    SalesChannelId: number;
    SelectionType: SelectionType;
    AllocationType: number;
}



// WEBPACK FOOTER //
// ./src/app/models/product-selection-type.ts